var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{attrs:{"auto-resize":"","highlight-hover-row":"","toolbar-config":_vm.tableToolbar,"data":_vm.tableData,"columns":_vm.tableColumns,"loading":_vm.loading,"height":_vm.tableHeight,"size":"small","resizable":"","border":"","seq-config":{
      startIndex: (_vm.tablePage.curPage - 1) * _vm.tablePage.pageSize,
    }},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header")]},proxy:true},{key:"pager",fn:function(){return [_vm._t("pager")]},proxy:true},{key:"syncStatus",fn:function(ref){
    var row = ref.row;
return [_c('el-tag',{attrs:{"size":"mini","type":row.syncStatus === 'N'
            ? 'primary'
            : row.syncStatus === 'Y'
            ? 'success'
            : row.syncStatus === 'E'
            ? 'warning'
            : ''}},[_vm._v(" "+_vm._s(row.v_syncStatus)+" ")])]}},{key:"opt",fn:function(ref){
            var row = ref.row;
return [_c('div',[_c('b-button-group',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"查看","placement":"top"}},[_c('i',{staticClass:"el-icon-view tool-btn",on:{"click":function($event){return _vm.$emit('openDetail', row)}}})])],1)],1)]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }